export default {
    buttons: {
        save: 'Save',
    },
    fields: {
        oldPassword: {
            label: 'Password',
            placeholder: 'Enter your password',
        },
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
    },
    errors: {
        user_can_not_change_email_10_days_from_sign_up: 'Changing of the email is not available 10 days after registration',
    },
}
